import { Sidebar } from '@coachhubio/nova-sidebar';

import { DashboardMenu } from './menus/DashboardMenu';
import { HumanLedCoachingMenu } from './menus/HumanLedCoachingMenu';

import { useFlags } from '~/lib/featureFlags';

export const DashboardSidebar = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const { newCmpSidebarDesign } = useFlags();
  return (
    <Sidebar
      menuItems={
        newCmpSidebarDesign ? (
          <DashboardMenu currentSectionIndex={currentSectionIndex} />
        ) : (
          <HumanLedCoachingMenu currentSectionIndex={currentSectionIndex} />
        )
      }
    />
  );
};
